module.exports = __webpack_public_path__ + "static/cosmetics-411351f2c3514e40c8fd1da62a0cfdf3.png";